import { GsFormSchema } from '../../../components/gs-form/interfaces/gs-form-schema';
import { DebitCardRewardsFilter, DebitCardVouchersFilter, VoucherType } from '../../../models/structure/components/page/debit-card-vouchers-component';
import { ACTIVE_SCHEMA_FIELDS, PAGINATED_SCHEMA_FIELDS, PICTURE_DISPLAY_MODE_SCHEMA } from '../basics';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { buttonSchemaFields } from './../basics/button-fields.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/** Form schema for the DebitCardVouchers component settings in the designer. */
export const DEBIT_CARD_VOUCHERS_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...ACTIVE_SCHEMA_FIELDS,
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    ...PAGINATED_SCHEMA_FIELDS,
    ...PICTURE_DISPLAY_MODE_SCHEMA,
    {
      formControlName: 'voucherType',
      label: 'components.debitCardVouchers.schema.voucherType',
      type: 'select',
      valueType: 'number',
      default: VoucherType.Discount,
      options: [
        { text: 'components.debitCardVouchers.schema.voucherTypeOptions.coupons', value: VoucherType.Discount },
        { text: 'components.debitCardVouchers.schema.voucherTypeOptions.rewards', value: VoucherType.Bonus }
      ]
    },
    {
      formControlName: 'rewardsFilter',
      label: 'components.debitCardVouchers.schema.rewardsFilter',
      type: 'select',
      valueType: 'number',
      default: DebitCardRewardsFilter.All,
      options: [
        { text: 'components.debitCardVouchers.schema.rewardsFilterOptions.all', value: DebitCardRewardsFilter.All },
        { text: 'components.debitCardVouchers.schema.rewardsFilterOptions.reached', value: DebitCardRewardsFilter.Reached },
        { text: 'components.debitCardVouchers.schema.rewardsFilterOptions.notReached', value: DebitCardRewardsFilter.NotReached }
      ],
      if: {
        args: [{ formControlName: 'voucherType', value: VoucherType.Bonus }]
      }
    },
    {
      formControlName: 'showFilterTabs',
      label: 'components.debitCardVouchers.schema.showFilterTabs',
      description: 'components.debitCardVouchers.schema.showFilterTabsDescription',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'filter',
      label: 'components.debitCardVouchers.schema.filter',
      type: 'select',
      valueType: 'number',
      default: DebitCardVouchersFilter.Available,
      options: [
        { text: 'components.debitCardVouchers.schema.filterOptions.available', value: DebitCardVouchersFilter.Available },
        { text: 'components.debitCardVouchers.schema.filterOptions.activated', value: DebitCardVouchersFilter.Activated },
        { text: 'components.debitCardVouchers.schema.filterOptions.devalued', value: DebitCardVouchersFilter.Devalued }
      ],
      if: {
        args: [{ formControlName: 'showFilterTabs', value: false }]
      }
    },
    {
      formControlName: 'buttons',
      label: 'components.debitCardVouchers.schema.buttons',
      type: 'group',
      expandable: true,
      default: {},
      fields: buttonSchemaFields()
    }
  ]
};
